import {DocumentDtoModel} from '../models/DTO/DocumentDto.model';
import {Injectable} from '@angular/core';
import {SessionService} from './session.service';

@Injectable({
  providedIn: 'root'
})

export class DocumentHelperService {

  constructor(private readonly sessionService: SessionService) {

  }

  public getMultiPartForDocument(document: DocumentDtoModel, file: File | null = null): FormData {
    const formData = new FormData();
    document.lastUpdatedById = <string>this.sessionService.getSession().user?.identification;
    document.lastUpdated = new Date();
    if (file != null) {
      document.setFileId('');
      formData.append('file', file, file.name);
    }
    formData.append('document', new Blob([JSON.stringify(document)], {type: 'application/json'}));
    return formData;
  }
}
